import React from "react";

export default ({ portfolio, price, currency, language }) => {
  window.rnwWidget = window.rnwWidget || {};
  window.rnwWidget.configureWidget = window.rnwWidget.configureWidget || [];
  window.rnwWidget.configureWidget.push(function(options) {
    options.epikOptions.test_mode = process.env.NODE_ENV !== "production";

    options.defaults["ui_onetime_amount_default"] = String(price * 100);

    options.widget.on(window.rnwWidget.constants.events.WIDGET_LOADED, function(
      event
    ) {
      event.widget.hideStep("amount");
    });

    options.defaults["stored_portfolio"] = portfolio.key;
  });

  // Remove old scripts
  document
    .querySelectorAll('[data-source="raisenow"]')
    .forEach(script => script.parentNode.removeChild(script));

  // Add new script
  const script = document.createElement("script");
  script.async = true;
  script.setAttribute("data-source", "raisenow");
  switch (currency) {
    case "EUR":
      script.src = `https://lema.raisenow.com/widgets/lema/stift-f51a/js/dds-init-widget-${language}.js`;
      break;
    case "CHF":
      script.src = `https://lema.raisenow.com/widgets/lema/mycli-2040/js/dds-init-widget-${language}.js`;
      break;
  }
  document.body.appendChild(script);

  return <div className="dds-widget-container" data-widget="lema"></div>;
};
